import { render, staticRenderFns } from "./ControlMoreModal.vue?vue&type=template&id=1299d5fe&scoped=true&"
import script from "./ControlMoreModal.vue?vue&type=script&lang=js&"
export * from "./ControlMoreModal.vue?vue&type=script&lang=js&"
import style0 from "./ControlMoreModal.vue?vue&type=style&index=0&id=1299d5fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1299d5fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1299d5fe')) {
      api.createRecord('1299d5fe', component.options)
    } else {
      api.reload('1299d5fe', component.options)
    }
    module.hot.accept("./ControlMoreModal.vue?vue&type=template&id=1299d5fe&scoped=true&", function () {
      api.rerender('1299d5fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/Camstudy/control/ControlMoreModal.vue"
export default component.exports